//语言
import {
    createI18n
} from 'vue-i18n' //引入vue-i18n组件
import Cookies from "js-cookie";

//注册i8n实例并引入语言文件
const defaultKey = 'zh_cn';
const i18n = createI18n({
    locale: Cookies.get('language') == undefined ? defaultKey : Cookies.get('language'), //默认显示的语言 
    messages: {
        zh_cn: require('./zh_cn.js'), //引入语言文件
        en_us: require('./en_us.js')
    }
})
export default {
    i18n,
    field: function (value) {
        if (value == null || value == undefined) {
            return "";
        }
        if (!value.hasOwnProperty(i18n.global.locale)) {
            return value[defaultKey];
        }
        if (value[i18n.global.locale] == "" || value[i18n.global.locale] == null) {
            return value[defaultKey];
        }
        return value[i18n.global.locale];
    }
}; //将i18n暴露出去，在main.js中引入挂载